import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from './bootstrap/Button';
import Modal, { ModalBody, ModalFooter, ModalHeader } from './bootstrap/Modal';
import Spinner from './bootstrap/Spinner';
import { userLoggedOut } from '../features/auth/authSlice';
import { clearCarts } from '../features/cart/cartSlice';
import {
	useShippingAgreementMutation,
	useShippingAgreementRejectMutation,
} from '../features/customers/customerApi';
import { demoPages } from '../menu';

// const formatDateDMY = (date) => {
// 	if (!date) return '';
// 	const d = new Date(date);
// 	const day = String(d.getDate()).padStart(2, '0');
// 	const month = String(d.getMonth() + 1).padStart(2, '0');
// 	const year = d.getFullYear();
// 	return `${day}/${month}/${year}`;
// };

const VehicleShippingAgreementModal = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { user, shipping_agreement } = useSelector((state) => state.auth);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const userInfo = user || {};

	const [isOpen, setIsOpen] = useState(false);
	// const [pdfUrl, setPdfUrl] = useState(null);
	// const [showPdfPreview, setShowPdfPreview] = useState(false);

	const [shippingAgreement, { isLoading }] = useShippingAgreementMutation();
	const [shippingAgreementReject, { isLoading: isLoadingReject }] =
		useShippingAgreementRejectMutation();

	useEffect(() => {
		if (userInfo) {
			const hasAccepted = userInfo?.role == 3 && shipping_agreement !== 1;

			if (hasAccepted) {
				setIsOpen(true);
			}
		}
	}, [userInfo, shipping_agreement]);

	const handleAccept = async () => {
		if (confirm(t('Are you agree with this condition !'))) {
			try {
				await shippingAgreement({ status: 1 }).unwrap();
				setIsOpen(false);
				// // Fetch the signed agreement PDF as a blob
				// const pdfResponse = await axios.get(
				// 	`${process.env.REACT_APP_API_BASE_URL}/customers/shipping-agreement-pdf`,
				// 	{
				// 		headers: {
				// 			Authorization: `Bearer ${accessToken}`,
				// 		},
				// 		responseType: 'blob',
				// 	},
				// );
				// const blobUrl = URL.createObjectURL(pdfResponse.data);
				// setPdfUrl(blobUrl);
				// setShowPdfPreview(true);

				const userData = localStorage.getItem('persist:auth');
				if (userData) {
					const data = JSON.parse(userData);
					const parsedAuth = JSON.parse(data.auth);
					parsedAuth.shipping_agreement = 1;
					data.auth = JSON.stringify(parsedAuth);
					localStorage.setItem('persist:auth', JSON.stringify(data));

					dispatch(userLoggedIn(parsedAuth));
				}
			} catch (err) {
				console.error('Shipping agreement accept error:', err);
			}
		}
	};

	const handleReject = async () => {
		if (confirm(t('Are you sure to reject this agreement !'))) {
			try {
				await shippingAgreementReject({ status: 2 }).unwrap();
				setIsOpen(false);
				dispatch(userLoggedOut());
				dispatch(clearCarts());
				localStorage.removeItem('notifications');
				navigate(`../${demoPages.login.path}`);
			} catch (err) {
				console.error('Shipping agreement reject error:', err);
			}
		}
	};

	return (
		<>
			<Modal
				isOpen={isOpen}
				setIsOpen={() => {
					// Non-closable: do nothing on backdrop/ESC
				}}
				isStaticBackdrop
				isScrollable
				size='xl'>
				<ModalHeader>
					<h3 className='modal-title'>{t('Vehicle Shipping Agreement')}</h3>
				</ModalHeader>

				<ModalBody>
					{/* <div className='prose prose-sm prose-headings:font-bold prose-headings:text-foreground max-w-none text-sm'>
						<div className='d-flex align-items-center justify-content-between'>
							<p className='fw-semibold fs-6 mb-0'>
								This Agreement is entered into between:
							</p>
							<p className='fw-semibold mb-0'>Date: {formatDateDMY(new Date())}</p>
						</div>

						<div className='my-4 d-flex flex-column flex-sm-row gap-4'>
							<div className='flex-fill border rounded p-3 bg-light'>
								<h6 className='fw-bold text-uppercase text-primary mt-0 mb-2'>
									Company
								</h6>
								<ul className='list-unstyled mb-0'>
									<li className='fw-semibold'>
										{process.env.REACT_APP_COMPANY_NAME}
									</li>
									<li>{process.env.REACT_APP_ADDRESS}</li>
									<li>License Number: </li>
								</ul>
							</div>
							<div className='flex-fill border rounded p-3 bg-light'>
								<h6 className='fw-bold text-uppercase text-primary mt-0 mb-2'>
									Customer
								</h6>
								<ul className='list-unstyled mb-0'>
									<li>
										<strong>Name:</strong> {userInfo?.name}
									</li>
									<li>
										<strong>Passport / ID:</strong> {userInfo?.photo_id}
									</li>
									<li>
										<strong>Phone:</strong> {userInfo?.phone}
									</li>
									<li>
										<strong>Address:</strong> {userInfo?.address_line_1}
									</li>
								</ul>
							</div>
						</div>

						<p className='fst-italic text-muted'>
							Together referred to as "the Parties."
						</p>

						<hr />

						<h5 className='text-primary'>1. Services</h5>
						<p>
							The Company agrees to provide vehicle shipping and logistics services
							for the transportation of the Customer's vehicle(s) which are purchased
							through the company auction accounts from the agreed origin to the
							agreed destination.
						</p>

						<hr />

						<h5 className='text-primary'>2. Shipping Charges</h5>
						<p>The Customer agrees to pay all charges related to:</p>
						<ul>
							<li>Ocean freight</li>
							<li>Inland transport</li>
							<li>Port handling</li>
							<li>Customs clearance</li>
							<li>Documentation</li>
							<li>Storage fees</li>
							<li>Any additional charges incurred during transport</li>
						</ul>
						<p>
							The total shipping cost will be stated in the invoice issued by the
							Company.
						</p>

						<hr />

						<h5 className='text-primary'>3. Payment Terms</h5>
						<p>
							The Customer must pay the invoice within thirty (30) days from the
							invoice date.
						</p>
						<p>Failure to pay within this period will result in:</p>
						<ul>
							<li>Late payment penalties</li>
							<li>Storage charges</li>
							<li>Possible legal recovery actions</li>
						</ul>

						<hr />

						<h5 className='text-primary'>4. Carrier's Lien and Right of Sale</h5>
						<p>
							The Customer acknowledges that the Company has a carrier's lien over the
							vehicle for all unpaid charges.
						</p>
						<p>
							If payment is not received within thirty (30) days, the Company has the
							right to:
						</p>
						<ul>
							<li>Hold the vehicle until payment is made</li>
							<li>Apply additional storage charges</li>
						</ul>
						<p>
							If payment remains unpaid for sixty (60) days or more, the Company may,
							after giving written notice to the Customer, sell the vehicle or cargo
							through auction or private sale to recover:
						</p>
						<ul>
							<li>Shipping charges</li>
							<li>Storage fees</li>
							<li>Administrative expenses</li>
							<li>Legal costs</li>
						</ul>
						<p>
							Any remaining balance after deductions will be returned to the Customer.
						</p>

						<hr />

						<h5 className='text-primary'>5. Customer Declaration</h5>
						<p>The Customer declares that:</p>
						<ul>
							<li>They are the legal owner or authorized agent of the vehicle.</li>
							<li>The vehicle is free of illegal goods or prohibited items.</li>
							<li>All documents provided are accurate and valid.</li>
						</ul>

						<hr />

						<h5 className='text-primary'>6. Liability</h5>
						<p>
							The Company will exercise reasonable care in handling and shipping the
							vehicle.
						</p>
						<p>However, the Company shall not be responsible for:</p>
						<ul>
							<li>
								Delays caused by weather, port congestion, customs, or government
								authorities
							</li>
							<li>Damage caused by acts of God, war, or force majeure</li>
							<li>Pre-existing damage to the vehicle</li>
						</ul>

						<hr />

						<h5 className='text-primary'>7. Storage Charges</h5>
						<p>
							If the vehicle is not collected or payment is delayed, the Company may
							charge daily storage fees starting from the date the vehicle arrives at
							the port or warehouse.
						</p>

						<hr />

						<h5 className='text-primary'>8. Governing Law</h5>
						<p>
							This Agreement shall be governed by the laws of the United Arab
							Emirates.
						</p>
						<p>
							Any disputes shall be resolved through the courts of the UAE unless
							otherwise agreed by the Parties.
						</p>

						<hr />

						<h5 className='text-primary mb-3'>9. Digital Acceptance</h5>
						<p>
							If this agreement is accepted through the Company's mobile application
							or website, the Customer agrees that:
						</p>
						<ul>
							<li>
								Clicking "Accept &amp; Continue" constitutes a legally binding
								digital signature.
							</li>
							<li>The Customer has read and agreed to all terms and conditions.</li>
						</ul>
						<p className='fw-semibold text-danger mt-3'>
							Failure to accept these terms will prevent the customer from proceeding
							with the shipment booking.
						</p>

						<div className='mt-5 d-flex align-items-center justify-content-between gap-4'>
							<div>
								<h6 className='fw-bold mb-1'>
									{process.env.REACT_APP_COMPANY_NAME}
								</h6>
								<p className='mb-1'>{process.env.REACT_APP_OWNER_NAME}</p>
								<div className='d-flex align-items-center gap-2'>
									<span className='fw-semibold small'>Signature:</span>
									<img
										src={ownerSignature}
										alt='Owner Signature'
										style={{ height: '64px', width: 'auto' }}
									/>
								</div>
							</div>
							<div>
								<p className='mb-0'>Customer Name:</p>
								<p className='mb-0 fw-bold'>{userInfo?.name}</p>
							</div>
						</div>
					</div> */}
					<iframe
						src={`https://api.plineshipping.com/assets/pdf/pline-contract.pdf#zoom=90&toolbar=1&navpanes=1&scrollbar=1`}
						className='w-100 border-0 bg-white'
						style={{ height: '75vh' }}
						// onLoad={() => setIsLoading(false)}
						title='PDF Viewer'
					/>
				</ModalBody>

				<ModalFooter className='d-flex justify-content-between'>
					<div>
						<Button
							color='danger'
							icon='Close'
							isDisable={isLoadingReject}
							onClick={handleReject}>
							{t('Reject')}
							{isLoadingReject && <Spinner isSmall inButton isGrow />}
						</Button>
						<p className='mt-2 mb-0 d-flex align-items-center gap-1 text-danger small'>
							<span>ⓘ</span>
							{t('If you reject, your account will be disabled.')}
						</p>
					</div>

					<Button
						color='success'
						icon='Check'
						isDisable={isLoading}
						onClick={handleAccept}>
						{t('Accept & Continue')}
						{isLoading && <Spinner isSmall inButton isGrow />}
					</Button>
				</ModalFooter>
			</Modal>

			{/* <PdfPreviewModal
				isOpen={showPdfPreview}
				onClose={() => setShowPdfPreview(false)}
				pdfUrl={pdfUrl}
				title={t('Shipping Agreement PDF')}
			/> */}
		</>
	);
};

export default VehicleShippingAgreementModal;
